import { getDb } from "@/db/sqlite";
import type { ProgressSyncRequest } from "@cdl/shared-types";

const MAX_BATCH = 500;

interface ApiLike {
  syncProgress(req: ProgressSyncRequest): Promise<{ applied: number }>;
}

export interface SyncResult { synced: number; }

export async function syncProgress(api: ApiLike): Promise<SyncResult> {
  const db = await getDb();
  const rows = await db.query(
    "SELECT id, type, payload, created_at FROM pending_events ORDER BY id ASC LIMIT ?",
    [MAX_BATCH]
  );
  const events = (rows.values ?? []) as Record<string, unknown>[];
  if (events.length === 0) return { synced: 0 };

  const body: ProgressSyncRequest = {
    events: events.map((r) => ({
      type: r.type as ProgressSyncRequest["events"][number]["type"],
      payload: JSON.parse(r.payload as string) as Record<string, unknown>,
      createdAt: r.created_at as string
    }))
  };

  const { applied } = await api.syncProgress(body);

  const ids = events.map((r) => r.id as number);
  const placeholders = ids.map(() => "?").join(",");
  await db.run(`DELETE FROM pending_events WHERE id IN (${placeholders})`, ids);

  return { synced: applied };
}
